import { render } from "./MDBModal.vue?vue&type=template&id=efd0bdd2"
import script from "./MDBModal.vue?vue&type=script&lang=js"
export * from "./MDBModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/repos/MDB/VUE/Release/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__